import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGenerateOtpMutation } from "../../../../redux/api/users.api";
import { executeWithCaptcha } from "../../../../app/functions";

import './index.scss';

//components
import PhoneValidation from '../../../login/phone_validation';
import Recaptcha from '../../../../components/services/google/recaptcha';
import { RECAPTCHA_ACTIONS } from 'components/services/google/recaptcha';
//assets
import desktop_exit from 'assets/icons/login-x-icon.svg';
import {getMediaPath} from "../../../../app/functions";

const PhoneValidationPopup = ({ popup_id, phone, data, action, onCancel, handleClose, process, isEditFlow }) => {
    const [animation_class, setAnimation_class] = useState('');
    const [otpResponseData, setOtpResponseData] = useState(null);
    const [generateOtpMutation] = useGenerateOtpMutation();
    const [captchaReady, setCaptchaReady] = useState(false);
    const deviceState = useSelector((state) => state.state.deviceState);
    const text = useSelector((state) => state.config.Translations);

    useEffect(() => {
        if (popup_id) {
            setAnimation_class('active');
        }
    }, [popup_id]);

    useEffect(() => {
        animateIn();
    }, []);

    useEffect(() => {
        if (phone && data?.userId && captchaReady) {
            generateInitialOtp();
        }
    }, [phone, data?.userId, captchaReady]);

    const animateIn = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setAnimation_class('active');
            })
        })
    }

    const animateOut = (callback) => {
        setAnimation_class('');
        setTimeout(() => {
            if(callback) {
                callback();
            }
            handleClose();
        }, 200);
    }

    const generateInitialOtp = async () => {
        if (phone && data?.userId && captchaReady) {
            const requestPayload = {
                userId: String(data.userId),
                cellphone: String(phone),
                process: process
            };

            executeWithCaptcha(async (token) => {
                requestPayload['g-recaptcha-response'] = token;
                try {
                    const result = await generateOtpMutation(requestPayload).unwrap();
                    setOtpResponseData(result);
                } catch (error) {
                    console.error('generateInitialOtp error', error);
                }
            }, RECAPTCHA_ACTIONS.VERIFY_CODE);
        }
    }

    return (
        <div className = { "backdrop " + animation_class } onClick = {() => animateOut(onCancel)}>
            <div className = {"popup_wrapper phone-validation-popup " + animation_class} onClick = { (e) => e.stopPropagation() }>
                <div className = "popup_content">
                    <button className = "x_close_icon"
                            onClick={() => animateOut(onCancel)}
                            aria-label="סגור">
                        <img src={ getMediaPath(desktop_exit) } alt="" />
                    </button>
                    <PhoneValidation 
                        process={process} 
                        phone={phone} 
                        userId={data?.userId}
                        data={data} 
                        action={action}
                        otpResponseData={otpResponseData}
                        isEditFlow={isEditFlow || false}
                    />
                    <Recaptcha 
                        enterprise={true} 
                        isFunction={true}
                        onReady={() => setCaptchaReady(true)}
                    />
                </div>
            </div>
        </div>
    )
}

export default PhoneValidationPopup;
